import {Box, Card, Skeleton, Typography} from '@mui/material';

const HiristJobDetailSkeleton = () => (
  <>
    <Box
      sx={{
        bgcolor: '#13355c',
        backgroundImage:
          "url('https://job-static.hirist.com/V8/static/media/background-bg.ba8365c7.webp')",
        backgroundRepeat: 'no-repeat',
        px: {xxs: 2, md: 6},
        pb: {xxs: 2, md: 9},
        pt: {xxs: 4.5, md: 7},
        display: 'flex',
        alignItems: 'flex-start',
        gap: {xxs: 1.5, md: 3},
      }}
    >
      <Skeleton
        variant="rounded"
        sx={{
          bgcolor: 'rgba(255,255,255,0.15)',
          flexShrink: 0,
          borderRadius: 2,
          width: {xxs: 48, md: 90},
          height: {xxs: 48, md: 90},
        }}
      />
      <Box flex={1}>
        <Skeleton
          width="65%"
          sx={{
            bgcolor: 'rgba(255,255,255,0.2)',
            mb: 0.5,
            height: {xxs: 22, md: 30},
          }}
        />
        <Skeleton
          width="40%"
          sx={{
            bgcolor: 'rgba(255,255,255,0.15)',
            mb: 1,
            height: {xxs: 15, md: 18},
          }}
        />
        <Box display="flex" gap={0.75} flexWrap="wrap" mb={1.25}>
          {[90, 105, 65, 55, 120, 75, 100].map((w, i) => (
            <Skeleton
              key={i}
              variant="rounded"
              width={w}
              sx={{
                bgcolor: 'rgba(255,255,255,0.15)',
                borderRadius: '20px',
                height: {xxs: 20, md: 26},
              }}
            />
          ))}
        </Box>
        <Skeleton
          width="30%"
          sx={{
            bgcolor: 'rgba(255,255,255,0.12)',
            height: {xxs: 12, md: 14},
          }}
        />
      </Box>
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: {xxs: 'column', md: 'row'},
        gap: {xxs: 2, md: 4},
        px: {xxs: 0, md: 6},
        mt: 3,
      }}
    >
      <Box sx={{width: {xxs: '100%', md: '62%', lg: '68%'}}}>
        <Typography
          component="h2"
          mt={0}
          mb={1.25}
          fontSize={22}
          fontWeight={700}
        >
          Job Description
        </Typography>
        <Card sx={{borderRadius: 2, p: 2.5}}>
          {[
            100, 100, 65, 100, 100, 50, 100, 100, 75, 100, 100, 60, 100, 100,
            80, 100, 55, 100, 100, 70, 100, 100, 45, 100, 100, 85, 100,
          ].map((w, i) => (
            <Skeleton key={i} height={15} width={`${w}%`} sx={{mb: 0.75}} />
          ))}
        </Card>
      </Box>
      <Box sx={{flex: 1}}>
        <Card sx={{borderRadius: 2, p: 2, mb: 2}}>
          <Skeleton height={13} width="40%" sx={{mb: 1.5}} />
          <Box display="flex" gap={1.5} alignItems="center" mb={1.5}>
            <Skeleton
              variant="circular"
              width={38}
              height={38}
              sx={{flexShrink: 0}}
            />
            <Box flex={1}>
              <Skeleton height={15} width="60%" sx={{mb: 0.4}} />
              <Skeleton height={13} width="75%" sx={{mb: 0.3}} />
              <Skeleton height={11} width="85%" />
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-around" mb={1.5}>
            {[0, 1, 2].map(i => (
              <Box key={i} textAlign="center">
                <Skeleton height={22} width={36} sx={{mx: 'auto', mb: 0.4}} />
                <Skeleton height={11} width={55} />
              </Box>
            ))}
          </Box>
          <Skeleton height={13} width="45%" sx={{mb: 0.3}} />
          <Skeleton height={14} width="65%" sx={{mb: 1.25}} />
          <Skeleton height={13} width="50%" sx={{mb: 0.3}} />
          <Skeleton height={14} width="70%" sx={{mb: 1.25}} />
          <Skeleton height={13} width="35%" sx={{mb: 0.3}} />
          <Skeleton height={14} width="30%" />
        </Card>
        <Card sx={{borderRadius: 2, p: 2}}>
          <Skeleton height={13} width="55%" sx={{mb: 1.5}} />
          <Skeleton variant="rounded" height={160} sx={{borderRadius: 1}} />
        </Card>
      </Box>
    </Box>
  </>
);

export default HiristJobDetailSkeleton;
